import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, MatchedProInfo, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const matchedProInfoAdapter = createEntityAdapter<JSONApiDataObject<MatchedProInfo>>({
  selectId: item => item.id
});

export const matchedProInfoSlice = createSlice({
  name: 'matchedProInfo',
  initialState: matchedProInfoAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<MatchedProInfo>>),
  reducers: {
    matchedProInfoAdded: (state, action) => {
      matchedProInfoAdapter.setMany(state, action.payload);
    }
  }
});

export const { matchedProInfoAdded } = matchedProInfoSlice.actions;
export const matchedProInfoSelectors = matchedProInfoAdapter.getSelectors(
  (state: RootState) => state.matchedProInfo);
